module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/library-assets/exercise/exercise.component.scss
// module id = ./src/app/library-assets/exercise/exercise.component.scss
// module chunks = main